import { render, staticRenderFns } from "./VendorProfile.vue?vue&type=template&id=269fc64b"
import script from "./VendorProfile.vue?vue&type=script&lang=js"
export * from "./VendorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269fc64b')) {
      api.createRecord('269fc64b', component.options)
    } else {
      api.reload('269fc64b', component.options)
    }
    module.hot.accept("./VendorProfile.vue?vue&type=template&id=269fc64b", function () {
      api.rerender('269fc64b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erp/VendorProfile.vue"
export default component.exports